import React from 'react';
import { PackageIcon, UsersIcon, MapIcon, SofaIcon, BuildingIcon, HomeIcon, GlobeIcon } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    icon: PackageIcon,
    title: 'Emergency Parcel & Item Delivery',
    description: 'When time is critical, our emergency delivery service ensures fast and secure transportation of parcels and items anywhere in the UK.'
  }, {
    icon: UsersIcon,
    title: 'Contract Delivery Driver Supply',
    description: 'We provide professional contractor delivery drivers to businesses requiring short-term or long-term logistics support.'
  }, {
    icon: MapIcon,
    title: 'Nationwide Delivery Coverage',
    description: 'Our nationwide delivery network allows us to reach any location in the UK quickly and efficiently.'
  }, {
    icon: SofaIcon,
    title: 'Furniture Delivery & Assembly',
    description: 'Our team offers furniture delivery and build services for homes, offices, and commercial environments.'
  }, {
    icon: BuildingIcon,
    title: 'Office Relocation Services',
    description: 'We specialise in efficient office relocations, ensuring business equipment and furniture are transported safely.'
  }, {
    icon: HomeIcon,
    title: 'House Relocation Services',
    description: 'Moving home? Our relocation specialists manage the transport and logistics to make your move stress-free.'
  }, {
    icon: GlobeIcon,
    title: 'International Migration Support',
    description: 'We assist with international relocation logistics, helping customers move and settle into new locations smoothly.'
  }];
  return <section className="py-20 bg-white" data-id="element-166">
      <div className="container mx-auto px-4" data-id="element-167">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-168">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-169">
            Our Services
          </h2>
          <p className="text-lg text-slate-600" data-id="element-170">
            Comprehensive logistics and delivery solutions tailored to your
            specific needs, available across the UK.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-171">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <div key={index} className="group bg-white rounded-2xl border border-slate-200 p-8 hover:border-primary hover:shadow-xl transition-all duration-300" data-id="element-172">
                <div className="h-14 w-14 bg-blue-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-primary group-hover:text-white transition-colors" data-id="element-173">
                  <Icon className="h-7 w-7 text-primary group-hover:text-white transition-colors" data-id="element-174" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-175">
                  {service.title}
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-176">
                  {service.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}